/**
 * Route registry — APPEND-ONLY (docs/AGENT_PROTOCOL.md, docs/modules/web.md "Route registry pattern").
 *
 * Feature agents: create `src/routes/<area>/index.tsx` exporting `<area>Routes: RouteObject[]` (elements built
 * with `lazyRoute()` so each screen is its own chunk), then append ONE spread line to the right array below:
 *
 *   - `lotteryRoutes`  → rendered inside `LotteryLayout` under `/l/:slug`; paths are RELATIVE (`'enter'`,
 *                        `'reveal/:entryId'`). `useLottery()` gives the published lottery, theme and refetch.
 *   - `routes`         → rendered inside `RootLayout`; paths are ABSOLUTE (`'/e/:entryId'`, `'/claim'`).
 *
 * `notFoundRoutes` (`*`) is appended last by the router — never add a catch-all here.
 */
import type { RouteObject } from 'react-router';
import { claimRoutes } from './claim';
import { entryRoutes } from './entry';
import { fairnessRoutes } from './fairness';
import { landingRoutes } from './landing';
import { preferencesRoutes } from './preferences';
import { receiptRoutes } from './receipt';
import { referralRoutes } from './referral';
import { resultsRoutes } from './results';
import { revealRoutes } from './reveal';
import { supportRoutes } from './support';
import { winRoutes } from './win';

/** Under `/l/:slug` (LotteryLayout). Relative paths. */
export const lotteryRoutes: RouteObject[] = [
  ...landingRoutes,
  ...entryRoutes,
  ...revealRoutes,
  ...resultsRoutes,
];

/** Top-level (RootLayout). Absolute paths. */
export const routes: RouteObject[] = [
  ...receiptRoutes,
  ...fairnessRoutes,
  ...claimRoutes,
  ...winRoutes,
  ...referralRoutes,
  ...supportRoutes,
  ...preferencesRoutes,
];
